//Landing trailers functionality.
(function(window, document, $){

	function init(opts){

		// video player params
		var params = {
			rel: 0,
			autoplay: 0,
			autohide: 1,
			controls: 1,
			modestbranding: 1,
			showinfo: 0,
			version: 3,
			enablejsapi: 1,
			wmode: 'opaque',
		};

		// root element to append video
		var $elem = opts.$videoTrailer;

		// mobile utilites
		var util = window.overwatch.util;

		// load youtube iframe api
		// $("<script>")
		// 	.attr("src", "https://www.youtube.com/iframe_api")
		// 	.appendTo($("body"));

		// create a video and append to the page
		// creates iframe on mobile
		// and uses iframe api on non-mobile devices
		function createPlayer(){

			// get the youtube video id
			var id = $elem.data('ytId');

			// append iframe for mobile devices
			if(util.mobile() || util.touch()){

				// hide image overlay
				$elem.toggleClass('active', true);

				// create the iframe and append to $elem
				var $iframe = $('<iframe/>',{
					attr: {
						width: '100%',
						height: '100%',
						allowFullScreen: true,
						frameBorder: 0,
						src: 'https://www.youtube.com/embed/' + id + '?' + $.param(params)
					}
				}).appendTo($elem);

			// handle non-mobile devices
			} else {

				// create placeholder div
				var $div = $('<div/>').appendTo($elem);

				// create player and embed video
				var player = new window.YT.Player($div[0], {
					videoId: id,
					playerVars: params,
					events: {
						onReady: function(event){
							$elem.on('click', function(){
								event.target.playVideo();
								$elem.toggleClass('active', true);
							});
						}
					}
				});

				$elem.on('click', function(event){
					event.preventDefault();
					$elem.toggleClass('active', true);
				});
			}
		};

		window.onYouTubeIframeAPIReady = function(){
			createPlayer();
		};

	};

	window.overwatch.OriginsTrailers = {
		init: init
	};

})(window, window.document, window.jQuery);
